import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const EcommerceWebsiteMaintenanceInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-commerce Website Maintenance in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Keep Your Store Running</Subheading>}
        heading={
          <Heading>
            E-commerce <span tw="text-primary-500">Website Maintenance</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide expert e-commerce website maintenance
            services in **Dubai**, ensuring your online store stays secure,
            updated, and optimized for peak performance. Keep your business
            thriving with our reliable support.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce maintenance dashboard
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Website maintenance team
          "https://images.unsplash.com/photo-1600267204091-5c1ab8b10c02?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Online store success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Maintain Your Store Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Reliable Maintenance Services in Dubai"
        description="We keep your e-commerce store at its best."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Regular Updates",
            description: "Keep plugins, themes, and platforms current.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Performance Optimization",
            description: "Ensure fast load times and smooth shopping.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Proactive Monitoring",
            description: "Catch issues before they impact sales.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Enhanced Security",
            description: "Protect your store from threats and hacks.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Compatibility",
            description: "Maintain seamless mobile experiences.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Support",
            description: "Dubai’s go-to for e-commerce maintenance.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Maintenance Process"
        description={
          <Description>
            We maintain your e-commerce store with care:
            <ul tw="mt-4 list-disc pl-6">
              <li>Assessment: Evaluate your store’s needs and performance.</li>
              <li>Updates: Apply software, security, and plugin updates.</li>
              <li>Optimization: Enhance speed, SEO, and user experience.</li>
              <li>Security: Implement backups and threat protection.</li>
              <li>Monitoring: Provide 24/7 uptime and issue tracking.</li>
              <li>Support: Offer ongoing fixes and improvements.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce maintenance tools
          "https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Website monitoring
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Testing and optimization
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Maintenance Success in Dubai"
        description="Our services keep stores thriving."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Uptime Boost",
            description: "Reduced downtime by 99% for a client.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Speed Gains",
            description: "Improved load times by 40% post-maintenance.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "95% satisfaction with maintenance plans.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Protect Your Store?</Subheading>}
        heading="E-commerce Website Maintenance in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for reliable e-commerce website
            maintenance in Dubai. Keep your online store secure, fast, and
            optimized—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Maintenance team collaboration
          "https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce website analytics
          "https://images.unsplash.com/photo-1534224039826-c7a0fb1c5c1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai skyline for local context
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
